/** Start optional I/O after the action's rendering opportunity. Hidden tabs still save. */
export function afterActionPaint<T>(save: () => T | Promise<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
        let started = false;
        const run = (): void => {
            if (started) return;
            started = true;
            clearTimeout(backstop);
            try { Promise.resolve(save()).then(resolve, reject); } catch (error) { reject(error); }
        };
        const backstop = setTimeout(run, typeof requestAnimationFrame !== 'function'
            || (typeof document !== 'undefined' && document.visibilityState === 'hidden') ? 0 : 100);
        if (typeof requestAnimationFrame === 'function') requestAnimationFrame(() => { setTimeout(run, 0); });
    });
}
